module.exports = __webpack_public_path__ + "static/media/promo-banner-mobile.7d3152de.jpg";